function findKeyByValue(object: any, targetValue: any) {
    for (const key in object) {
      if (object.hasOwnProperty(key) && object[key] === targetValue) {
        return key; // Return the first key that matches the targetValue
      }
    }
    return null; // Return null if the value is not found
  }

export default findKeyByValue